export default "__VITE_ASSET__XLFCkzEU__"